<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>İlgili Site Bağlantıları</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-alert
        variant="info"
        :show="dataItem.urls.length === 0"
      >
        <div class="alert-body text-center">
          <FeatherIcon icon="InfoIcon" />
          Henüz eklenmiş bağlantı bulunmuyor. Bağlantı tanımlamak için "Bağlantı Ekle" butonuna tıklayın.
        </div>
      </b-alert>
      <b-row
        v-for="(item,key) in dataItem.urls"
        :key="key"
      >
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group
            label="Adres Tanımı"
            :label-for="'item_title' + key"
          >
            <b-form-input
              :id="'item_title' + key"
              v-model="item.title"
              placeholder="Adres Tanımı"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="8"
        >
          <b-form-group
            label="Sayfa Bağlantısı"
            :label-for="'item_link' + key"
          >
            <b-input-group>
              <b-form-input
                :id="'item_link' + key"
                v-model="item.url"
                type="url"
                placeholder="Sayfa Bağlantısı"
              />
              <b-input-group-append>
                <b-button
                  variant="danger"
                  @click="removeItem(key)"
                >
                  <FeatherIcon icon="XCircleIcon" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-footer>
      <b-button @click="addItem">
        <FeatherIcon icon="PlusCircleIcon" /> Bağlantı Ekle
      </b-button>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol, BCard, BCardBody, BCardFooter, BButton, BCardHeader, BCardTitle, BInputGroup, BInputGroupAppend,
  BAlert,
} from 'bootstrap-vue'

export default {
  name: 'UrlsCard',
  components: {
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardFooter,
    BButton,
    BCardHeader,
    BCardTitle,
    BInputGroup,
    BInputGroupAppend,
    BAlert,
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  methods: {
    addItem() {
      this.dataItem.urls.push({
        title: null,
        url: null,
      })
    },
    removeItem(key) {
      this.dataItem.urls.splice(key, 1)
    },
  },
}
</script>
